import React, { Fragment, useState } from "react";
import close from "../../../assets/images/model/close.svg";
import filePlus from "../../../assets/images/model/upload_arrow.svg";
import infoCreate from "../../../assets/images/model/info-create.svg";
import polygonArrow from "../../../assets/images/model/Polygon-dowan-arrow.svg";
import audioPlay from "../../../assets/images/model/videoPlay.svg";

const UploadAudio = ({ setUploadAudioShow }) => {
  const [uploadAudio, setUploadAudio] = useState(true);
  const [uploadLoadingAudio, setUploadLoadingAudio] = useState(false);
  const [uploadLoadedAudio, setUploadLoadedAudio] = useState(false);

  const handleClose = () => {
    setUploadAudioShow(false);
  };

  const handleUpload = () => {
    setUploadAudio(false);
    setUploadLoadingAudio(true);
  };

  const handleUploadComplete = () => {
    setUploadLoadedAudio(true);
    setUploadLoadingAudio(false);
    setUploadAudio(false);
  };

  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={handleClose}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>add audio</h4>
              {uploadAudio && (
                <Fragment>
                  <p>
                    Drag and drop an audio file from your computer. Add
                    attribution in the next step.
                  </p>
                  <form action="" className="upload_book">
                    <div className="upload_book_inner my-40 mb-0">
                      <div className="drag_and_drop_box" htmlFor="Drag-file">
                        <div className="upload_content">
                          <div className="icon-create mb-24">
                            <img src={filePlus} alt="upload" />
                          </div>
                          <div className="deflat_content">
                            <h6 className="f-size-18 theme__primary__text">
                              <span onClick={handleUpload}>
                                Drag and drop file, or{" "}
                              </span>
                              <a href="#">
                                {" "}
                                <input type="file" id="Drag-file" /> Browse{" "}
                              </a>
                            </h6>
                            <p>Supports mp3 files | Max 50mb size</p>
                          </div>
                          <div
                            className="file_upload_content"
                            style={{ display: "none" }}
                          >
                            <p>
                              Spanish_book_101.pdf
                              <a href="#">
                                <img src={close} alt="close" />
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}
              {uploadLoadingAudio && (
                <Fragment>
                  <form action="" className="upload_book">
                    <div className="upload_book_inner my-40 mb-0">
                      <div
                        className="drag_and_drop_box upload-boarder"
                        htmlFor="Drag-file"
                      >
                        <div className="upload_content">
                          <div className="icon mb-24"> </div>
                          <div className="deflat_content">
                            <div
                              className="circle"
                              onClick={handleUploadComplete}
                            >
                              <b>
                                <span>50%</span>
                              </b>
                            </div>
                            <h6 className="f-size-18 theme__primary__text">
                              Uploading audio...
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Fragment>
              )}
              {uploadLoadedAudio && (
                <Fragment>
                  <div className="add_img_cre">
                    <form action="" className="pick_from_library">
                      <div className="pick_from_library_filter_wrap">
                        <div className="pick_from_library_filter my-40 ">
                          <div className="conten_center my-40 mb-24">
                            <div
                              className="drag_and_drop_box upload-boarder audio_padding"
                              htmlFor="Drag-file"
                            >
                              <div className="deflat_content   ">
                                <span className="audio_file">
                                  audiofilename.m4a
                                </span>
                                <span className="audio_size">6:21 (6MB)</span>
                              </div>
                              <div className=" audio_progress">
                                <div className="audio_play">
                                  <img src={audioPlay} alt="audio play" />
                                </div>
                                <div className="audio_bar"></div>
                              </div>
                            </div>
                          </div>
                          <div className="icon">
                            <div className="tooltip_wrap Attribution">
                              <h2 className="icon_h2 mb-0">
                                Attribution{" "}
                                <img
                                  src={infoCreate}
                                  className="info_tooltip"
                                  alt="Info"
                                />
                              </h2>
                              <p>
                                Provide the source of the audio to give creator
                                credit <img src={polygonArrow} alt="Polygo" />
                              </p>
                            </div>
                            <input
                              style={{ height: "60px" }}
                              type="text"
                              className="pick_from_input_cre border_color"
                              placeholder="Paste the link..."
                            />
                          </div>
                        </div>
                      </div>
                      <div className="modal-btn">
                        <button type="button" className="btn-black_create">
                          Done
                        </button>
                      </div>
                    </form>
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadAudio;
